import { LoadingZone, useRegisterLoadingState } from '@zenbusiness/application-commons-loading';
import ErrorState from '@zenbusiness/zui/ErrorState';
import SkeletonGrid from '@zenbusiness/zui/SkeletonGrid';
import Stack from '@zenbusiness/zui/Stack';
import PropTypes from 'prop-types';

import { Balance } from './components/Balance';
import { BankingGrid } from './components/BankingGrid';
import { Transactions } from './components/Transactions';

import { useBankingWidget } from './hooks/useBankingWidget';

function BankingWidgetV2({ widgetId }) {
  const { data, error, loading, refetch } = useBankingWidget();
  // Register: Add widget to the global widget state.
  useRegisterLoadingState({
    loadId: widgetId,
    status: (() => {
      if (loading) {
        return LoadingZone.PENDING;
      }
      return LoadingZone.DONE;
    })()
  });

  // Loading: Data is loading.
  if (loading) {
    return (
      <SkeletonGrid
        columns={2}
        count={2}
      />
    );
  }

  // Error: Data failed to load.
  if (error) {
    return (
      <ErrorState
        onReload={refetch}
        slotProps={{
          primaryAction: {
            eventProps: {
              pageSection: 'home'
            }
          }
        }}
      />
    );
  }

  return (
    <BankingGrid aria-label="Banking widget">
      <Stack gap="12px">
        <Balance
          accountDetails={data.accountDetails}
          addFundModalHref={data.addFundModalHref}
          availableBalance={data.availableBalance}
        />
      </Stack>
      <Transactions transactions={data.transactions} />
    </BankingGrid>
  );
}

BankingWidgetV2.propTypes = {
  /** Unique ID to use for the widget */
  widgetId: PropTypes.string
};

export default BankingWidgetV2;
